import React from 'react';
import styled from 'styled-components';


/*

Props:


*/

const StyledDiv = styled.div`
  display: flex; 
  flex-grow: 1;
  justify-content: flex-start; 
  align-items: center; 
  padding-top: 40px;
  background-color: white;
  padding: 15px 20px 20px 20px;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
  margin-top: -84px;
  max-width: 300px;

  @media screen and (max-width: 400px) {
    margin-top: 0px;
  }
`;

const OverlapPanel = ({ styles, children, ...rest }) => (
  <StyledDiv style = {styles} {...rest}>
      { children }
  </StyledDiv>
)

export default OverlapPanel



// WEBPACK FOOTER //
// ./src/js/components/OverlapPanel/OverlapPanel.jsx